import { EditOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IADefaultLanguageEdit } from './IADefaultLanguageEdit';
import { useIsAuthorized } from '../../../../pages/common/roles/Roles';

export const IADefaultLanguage = (props: { language: string, groupAccount: string, locationId?: string }) => {

	const [edit, setEdit] = useState(false);
	const [language, setLanguage] = useState(props.language);
	const { t } = useTranslation();
	const isAuthorized = useIsAuthorized();
	const canEdit = isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT']);

	return (
		<Card
			className='card-layout'
			bodyStyle={{ padding: '14px 16px' }}
			style={{
				background: '#fff',
				margin: 0,
				marginLeft: 0,
				width: '100%',
				borderRadius: 10,
				border: '1px solid rgba(148, 163, 184, 0.28)',
			}}
		>
			{!edit ? (
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: 12,
				}}>
					<div style={{ minWidth: 0 }}>
						<div style={{
							fontSize: 13,
							fontWeight: 600,
							color: '#0f172a',
							lineHeight: 1.3,
						}}>
							Idioma de las respuestas
						</div>
						<div style={{
							fontSize: 12,
							color: '#64748b',
							lineHeight: 1.4,
							marginTop: 2,
						}}>
							Idioma que usará la IA por defecto al generar respuestas.
						</div>
					</div>
					<div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
						<div style={{
							borderRadius: 6,
							border: '1px solid #e2e8f0',
							background: '#edf2f7',
							color: '#475569',
							padding: '4px 10px',
						}}>
							<small style={{ fontWeight: 700 }}>{language}</small>
						</div>
						{canEdit && (
							<button
								type="button"
								onClick={() => setEdit(true)}
								style={{
									border: 'none',
									background: 'transparent',
									cursor: 'pointer',
									color: '#64748b',
									padding: 4,
									display: 'flex',
									alignItems: 'center',
								}}
								title={t('dictionary.edit', { defaultValue: 'Editar' })}
							>
								<EditOutlined />
							</button>
						)}
					</div>
				</div>
			) : (
				<div>
					<div style={{
						fontSize: 13,
						fontWeight: 600,
						color: '#0f172a',
						lineHeight: 1.3,
						marginBottom: 10,
					}}>
						Idioma de las respuestas
					</div>
					<IADefaultLanguageEdit
						defaultLanguage={language}
						onEdit={(nextLanguage: any) => { setLanguage(nextLanguage); setEdit(false); }}
						onCancel={() => { setEdit(false); }}
						locationId={props.locationId}
					/>
				</div>
			)}
		</Card>
	);
};
